namespace TabAurous.Reports {
    export interface StockBifurcationRow {
        TransId?: number;
        TransItemId?: number;
        ProductId?: number;
        AttributeId?: number;
        Status?: string;
        DepartmentName?: string;
        LedgerName?: string;
        CustomerName?: string;
        TransDate?: string;
        Company?: string;
        Image?: string;
        ImageLength?: number;
        ProductCode?: string;
        ProductName?: string;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        MetalGrossWeight?: number;
        MetalNetWeight?: number;
        MetalNetAmount?: number;
        KaratId?: number;
        MetalName?: string;
        MetalColorName?: string;
        KaratName?: string;
        StoneProductType?: string;
        StoneType?: string;
        StonePieces?: number;
        TotalStoneWeight?: number;
        StoneWeight?: number;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        StoneSizeName?: string;
        SieveName?: string;
        GroupSieveName?: string;
        UnitLabour?: number;
        TotalLabour?: number;
        Discount?: number;
        GrossAmount?: number;
        Remark?: string;
        MF?: number;
        MFAmount?: number;
        SKU?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
        PurchaseVoucher?: string;
        PurchasePieces?: number;
        PurchaseWeight?: number;
        SalesVoucher?: string;
        SalesPieces?: number;
        SalesWeight?: number;
        RemainingPieces?: number;
        RemainingWeight?: number;
    }

    export namespace StockBifurcationRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'Reports.StockBifurcation';
        export const deletePermission = 'Reports:Transaction:Stock Bifurcation';
        export const insertPermission = 'Reports:Transaction:Stock Bifurcation';
        export const readPermission = 'Reports:Transaction:Stock Bifurcation';
        export const updatePermission = 'Reports:Transaction:Stock Bifurcation';

        export declare const enum Fields {
            TransId = "TransId",
            TransItemId = "TransItemId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Status = "Status",
            DepartmentName = "DepartmentName",
            LedgerName = "LedgerName",
            CustomerName = "CustomerName",
            TransDate = "TransDate",
            Company = "Company",
            Image = "Image",
            ImageLength = "ImageLength",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            MetalGrossWeight = "MetalGrossWeight",
            MetalNetWeight = "MetalNetWeight",
            MetalNetAmount = "MetalNetAmount",
            KaratId = "KaratId",
            MetalName = "MetalName",
            MetalColorName = "MetalColorName",
            KaratName = "KaratName",
            StoneProductType = "StoneProductType",
            StoneType = "StoneType",
            StonePieces = "StonePieces",
            TotalStoneWeight = "TotalStoneWeight",
            StoneWeight = "StoneWeight",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            GroupSieveName = "GroupSieveName",
            UnitLabour = "UnitLabour",
            TotalLabour = "TotalLabour",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            MF = "MF",
            MFAmount = "MFAmount",
            SKU = "SKU",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId",
            PurchaseVoucher = "PurchaseVoucher",
            PurchasePieces = "PurchasePieces",
            PurchaseWeight = "PurchaseWeight",
            SalesVoucher = "SalesVoucher",
            SalesPieces = "SalesPieces",
            SalesWeight = "SalesWeight",
            RemainingPieces = "RemainingPieces",
            RemainingWeight = "RemainingWeight"
        }
    }
}
